import { atom, RecoilState } from 'recoil';
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist();

export const OrganisationAtom: RecoilState<{
	OrganisationId: number;
	OrganisationName: string;
	SetaTypeId?: string;
	ShowPayrollIntegrationMenuItems?: boolean;
}> = atom<{ OrganisationId: number; OrganisationName: string; SetaTypeId?: string; ShowPayrollIntegrationMenuItems?: boolean }>({
	key: 'OrganisationAtom',
	default: {
		OrganisationId: -1,
		OrganisationName: '',
		ShowPayrollIntegrationMenuItems: false
	} as { OrganisationId: number; OrganisationName: string; SetaTypeId?: string; ShowPayrollIntegrationMenuItems?: boolean },
	effects_UNSTABLE: [persistAtom]
});
